import * as $ from 'jquery';
import { IDialog, IDialogOptions } from 'runtime/dialogs/dialog';
import { IResourceProvider } from 'common/resourceprovider';

export class ConfirmUploadDialog implements IDialog {
    private $input: JQuery;
    private $dialogContent: JQuery;
    options: IDialogOptions;

    constructor(resources: IResourceProvider, action: (x: HTMLInputElement) => void) {
        this.options = { title: resources.getCoreString('ConfirmFileUploadDialogTitle') };

        this.$dialogContent = $('<div />').addClass('confirmuploaddialog');
        var $label = $('<label />').text(resources.getCoreString('ConfirmFileUploadDialogText')).button().appendTo(this.$dialogContent);
        var $input = $('<input type="file" />').addClass('invisible-but-not-hidden').appendTo($label);
        $input.on('change', () => {
            action(<HTMLInputElement>$input[0]);
            this.$dialogContent.dialog('close');
        });
    }

    content() {
        return this.$dialogContent;
    }
}